module.exports = __webpack_public_path__ + "static/media/icon-redux.023cdb4d.svg";